import { Checkbox, Form, notification } from 'antd'
import { showDefaultQueries } from './shared'
import { QueryEditor } from 'Components'

SpreadSheet = ({ extra, setFieldsValue }) ->
  <>
  { showDefaultQueries('Sparql', setFieldsValue) }
  <Form.Item
    name='query'
    required
    extra={extra}
    data-testid="create-spreadsheet-view-query"
  >
    <QueryEditor mode='Sparql' placeholder="Spreadsheet Query" />
  </Form.Item>
  <Form.Item
    name='isPublic'
    valuePropName="checked"
  >
    <Checkbox data-testid="create-spreadsheet-view-is-public-query">Show view if project is public?</Checkbox>
  </Form.Item>
  </>

SpreadSheet.validateQuery = (fields) ->
  bindings = await new Weaver.Sparql(fields.query)
    .limit(0)
    .find()
  if not bindings.node
    throw new Error("No ?node binding found. Spreadsheet queries are required to select a single binding, which should be named ?node.")
  if _.keys(bindings).length > 1
    notification.warning({
      message: "Multiple bindings found."
      description: "The query you entered selects more than one binding. This will not cause errors, but additional bindings on top of the ?node binding will not be collected."
      duration: 5
    })

export default SpreadSheet
